
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industrial_safety",
      function () {
        return require("private-next-pages/industrial_safety/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industrial_safety"])
      });
    }
  